import angular from 'angular';

import { changePageTitle } from 'auth/actions/session.actions';
import errorCodesModule from './config/errorcodes.conf';
import downloadPageModule from './components/download-page/download-page-module';

export default angular.module('download-report-page', [downloadPageModule.name, errorCodesModule.name]).config([
  '$stateProvider',
  ($stateProvider) => {
    $stateProvider.state('download-report', {
      parent: 'arw',
      url: '/download-report/:token',
      params: {
        hideMenu: true,
        pageTitle: [
          '$ngRedux',
          'gettextCatalog',
          ($ngRedux, gettextCatalog) => {
            $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Report Download')));
          },
        ],
      },
      withoutPerms: true,
      template: '<download-page></download-page>',
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/download-report-page/download-report-page-module.js